import script from "./UIconRounded.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIconRounded.vue?vue&type=script&setup=true&lang=ts"

import "./UIconRounded.vue?vue&type=style&index=0&id=0b81aedf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b81aedf"]])

export default __exports__